import Model from './Model'
import PaymentTransaction from './PaymentTransaction'
export default class Invoice extends Model {

    resource()
    {
        return 'invoices'
    }

    get downloadEndpoint() {
        return `${this.endpoint()}/download`
    }
}
